import { useState, useCallback } from 'react';

export default function useToast() {
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const close = useCallback(() => setToast(t => ({ ...t, open: false })), []);
  return { toast, setToast, close };
}
